// @mui material components

// @mui icons
import GitHubIcon from "@mui/icons-material/GitHub";

// Pages
import AboutUs from "layouts/pages/landing-pages/about-us";
import { AccountCircle, CardTravel, Dashboard } from "@mui/icons-material";
import Presentation from "pages/Presentation";
import Realisation from "pages/LandingPages/Realisation";

const routes = [
  {
    name: "Accueil",
    icon: <Dashboard />,
    route: "/",
    component: <Presentation />,
  },
 
  {
    name: "Réalisation",
    icon: <CardTravel />,
    route: "/realisation",
    component: <Realisation />,
  },
  {
    name: "À propos",
    icon: <AccountCircle />,
    route: "/apropos",
    component: <AboutUs />,
  },
  {
    name: "github",
    icon: <GitHubIcon />,
    href: "https://github.com/rakotozafy",
  },
];

export default routes;
